import React from 'react';
import { Mail, GraduationCap, Heart, Rocket } from 'lucide-react';

const ThankYouSlide = () => {
  return (
    <div className="slide active min-h-screen w-full flex flex-col justify-center items-center px-6 md:px-12 relative overflow-hidden">
      {/* Animated background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full opacity-20 animate-float" style={{ background: 'var(--gradient-primary)', filter: 'blur(100px)' }} />
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 rounded-full opacity-15 animate-float" style={{ background: 'var(--gradient-primary)', filter: 'blur(80px)', animationDelay: '2s' }} />
      </div>
      
      <div className="relative z-10 text-center max-w-3xl stagger-children">
        {/* Icon */}
        <div className="flex justify-center mb-8">
          <div className="p-4 rounded-2xl bg-primary/10 border border-primary/20">
            <GraduationCap className="w-12 h-12 text-primary" />
          </div>
        </div>
        
        {/* Thank you message */}
        <h1 className="font-heading text-4xl md:text-6xl font-bold mb-6">
          <span className="text-foreground">Thank You!</span>
        </h1>
        
        <p className="text-lg text-muted-foreground mb-8 max-w-xl mx-auto">
          Questions? Let's discuss reasoning models, network automation, or anything from today's lecture.
        </p>
        
        {/* Remember message */}
        <div className="p-6 rounded-2xl bg-gradient-to-r from-primary/10 via-secondary/10 to-accent/10 border border-primary/20 max-w-2xl mx-auto mb-8">
          <div className="flex items-start gap-3">
            <Heart className="w-5 h-5 text-destructive flex-shrink-0 mt-1" />
            <p className="text-foreground text-left">
              <strong>Remember:</strong> Reasoning models are powerful tools, but always verify critical decisions with domain expertise!
            </p>
          </div>
        </div>
        
        {/* vExpertAI Internship CTA */}
        <div className="p-6 rounded-2xl bg-primary/10 border-2 border-primary/40 max-w-2xl mx-auto">
          <div className="flex items-center justify-center gap-3 mb-3">
            <Rocket className="w-6 h-6 text-primary" />
            <h3 className="font-heading text-xl font-bold text-primary">Join Us!</h3>
          </div>
          <p className="text-foreground text-lg mb-4">
            <strong>vExpertAI</strong> is looking for internship collaborators to build the future of IT using AI!
          </p>
          <div className="flex items-center justify-center gap-2">
            <Mail className="w-5 h-5 text-primary" />
            <a href="mailto:ed@vexpertai.com" className="text-primary font-mono text-lg hover:underline">
              ed@vexpertai.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouSlide;
